const routes = [
  {
    path: "/app-upgrade",
    name: "newAppMarketUpgradeDialog",
    component: () => import(/* webpackChunkName: "upgrade" */ "./views/Upgrade")
  },
  {
    path: "/app-info/:codeName",
    name: "AppInfo",
    component: () => import(/* webpackChunkName: "AppInfo" */ "./views/AppInfo")
  },
];
export default routes;
